import axiosInstance from "api/setupAxios";

const invoiceApi = {
  listPOsForInvoiceCreation: async (query = {}) => {
    const { paginate = {} } = query;
    const { pageSize = 10, pageNumber = 1 } = paginate;

    const data = await axiosInstance.get(`/agency/listPOs/invoiceCreation`, {
      params: {
        paginate: JSON.stringify({ pageSize, pageNumber }),
        sort: JSON.stringify([["created_at", "desc"]]),
        filter: JSON.stringify(query.filter),
      },
    });

    return data?.data ?? data; // expect { count, result }
  },

  submitInvoiceGroup: async (payload = {}) => {
    const res = await axiosInstance.post(
      "/agency/purchaseOrderInvoiceGroupe",
      payload
    );
    return res?.data ?? res;
  },

  // Invoices page APIs
  getAgencyInvoices: async (query = {}) => {
    const { paginate = {} } = query;
    const { pageSize = 10, pageNumber = 1 } = paginate;
    const response = await axiosInstance.get(
      "/agency/purchaseOrderInvoiceGroupe",
      {
        params: {
          paginate: JSON.stringify({ pageSize, pageNumber }),
          sort: JSON.stringify([["created_at", "desc"]]),
          filter: JSON.stringify(query.filter),
        },
      }
    );

    return response?.data ?? response; // { count, result }
  },

  editAgencyInvoice: async (payload = {}) => {
    const { data } = await axiosInstance.patch(
      "/agency/purchaseOrderInvoiceGroupe",
      payload
    );
    return data?.data ?? data;
  },

  // Get a signed URL to download an invoice file by its ID
  getInvoiceUrl: async (invoiceId) => {
    const { data } = await axiosInstance.get(
      `/agency/purchaseOrderInvoiceGroupe/${invoiceId}/url`
    );
    return data;
  },

  resendAgencyInvoice: async (invoiceId) => {
    const { data } = await axiosInstance.patch(
      `/agency/purchaseOrderInvoiceGroupe/${invoiceId}`,
      {}
    );
    return data?.data ?? data;
  },
};

export default invoiceApi;
